import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatErr } from "../lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [err, setErr] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        setLoading(true);
        try {
            await api.post("/auth/forgot-password", { email });
            setSubmitted(true);
            toast.success("Email envoyé si un compte existe");
        } catch (e) {
            setErr(formatErr(e.response?.data?.detail));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-[78vh] flex items-center justify-center px-6 py-16">
            <div className="w-full max-w-md">
                <div className="text-[11px] uppercase tracking-[0.25em] text-orange-500 font-bold mb-2">
                    Mot de passe oublié
                </div>
                <h1 className="font-display text-5xl uppercase tracking-tight mb-8">
                    Réinitialiser votre mot de passe
                </h1>

                {submitted ? (
                    <div className="card-tu space-y-4" data-testid="forgot-confirmation">
                        <p className="text-zinc-200">
                            Si un compte est associé à <strong className="text-orange-500">{email}</strong>,
                            vous allez recevoir dans quelques minutes un email avec un lien de réinitialisation.
                        </p>
                        <p className="text-xs text-zinc-500">
                            Le lien est valable <strong>1 heure</strong> et ne peut être utilisé qu'une seule fois.
                            Pensez à vérifier vos spams.
                        </p>
                        <div className="pt-3">
                            <Link to="/login" className="btn-ghost py-2 px-4 text-xs">
                                Retour à la connexion
                            </Link>
                        </div>
                    </div>
                ) : (
                    <form onSubmit={submit} className="card-tu space-y-5">
                        <p className="text-sm text-zinc-400">
                            Indiquez votre email. Vous recevrez un lien pour choisir un nouveau mot de passe.
                        </p>
                        <div>
                            <label className="label-tu">Email</label>
                            <input
                                data-testid="forgot-email"
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="input-tu"
                                placeholder="votre@email.fr"
                            />
                        </div>
                        {err && (
                            <div className="text-sm text-red-500 border border-red-900/50 bg-red-950/30 p-3">
                                {err}
                            </div>
                        )}
                        <button
                            data-testid="forgot-submit"
                            disabled={loading}
                            className="btn-primary w-full"
                        >
                            {loading ? "Envoi…" : "Envoyer le lien"}
                        </button>
                        <div className="text-center">
                            <Link
                                to="/login"
                                className="text-xs uppercase tracking-widest text-zinc-400 hover:text-orange-500"
                            >
                                Retour à la connexion
                            </Link>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
}
